<script setup lang="ts">
import { RouterLink } from 'vue-router';
import LogoIcon from '@/assets/images/logos/new-logo-icon.png';
</script>
<template>
    <div class="logo">
        <RouterLink to="/">
            <img :src="LogoIcon" alt="home" style="width: 35px; height: 35px;" />
        </RouterLink>
    </div>
</template>
